import extensibilityState from './store';
import type Extension from 'owa-service/lib/contract/Extension';

export function getExtensionForAddinId(addinId: string): Extension {
    const context = extensibilityState.Context;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (9,21): Object is possibly 'undefined'.
    // @ts-expect-error
    for (let ext of context.Extensions) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (13,13): Object is possibly 'undefined'.
        // @ts-expect-error
        if (ext.Id.toLowerCase() === addinId.toLowerCase()) {
            return ext;
        }
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (20,5): Type 'null' is not assignable to type 'Extension'.
    // @ts-expect-error
    return null;
}
